// TODO - remove lint disable when editing this file
/* eslint-disable */
import { ContentBlock, CharacterMetadata } from 'draft-js'
import { COLOR_STYLE_PREFIX } from '~/redux/customColors'

const TAG_REGEX = /<mark\W+(?:class\W*=\W*"([^"]+)")?\W*>([\s\S]*?)<\W*\/mark\W*>/gim

const START_BOUNDARY = '8K9zbUMi3d2yvD9i'
const END_BOUNDARY = '3ooSk6G6fYXhP42P'

const createBoundaryRegexp = (boundary) =>
  new RegExp(`\\|${boundary}\\-(.*?)\\-${boundary}\\|`, 'gm')
const START_MARK_REGEX = createBoundaryRegexp(START_BOUNDARY)
const END_MARK_REGEX = createBoundaryRegexp(END_BOUNDARY)

export const _regexSearch = (regex, text) => {
  regex.lastIndex = 0
  const match = regex.exec(text)
  if (!match) {
    return null
  }
  const [fullMatch, colorClass, innerText] = match
  const { index } = match
  return { fullMatch, colorClass, innerText, index }
}

// Since Draft convertFromHTML() has no configuration to preserve <mark> tag in a custom styles
// this hack is needed. highlightsHydrateMarks should replace all <mark>...</mark>
// tags with START_BOUNDARY - color_class - END_BOUNDARY to pass it through convertFromHTML() unchangeg
export const highlightsHydrateMarks = (html, ans, options) => {
  while (true) {
    const match = _regexSearch(TAG_REGEX, html)
    if (!match) {
      break
    }
    const { fullMatch, colorClass, innerText, index } = match
    html =
      html.slice(0, index) +
      `|${START_BOUNDARY}-${colorClass}-${START_BOUNDARY}|${innerText}|${END_BOUNDARY}-${colorClass}-${END_BOUNDARY}|` +
      html.slice(index + fullMatch.length)
  }
  return html
}

export const _stripCharacters = (contentBlock, start, len) => {
  const text = contentBlock.getText()
  const updatedText = text.slice(0, start) + text.slice(start + len)

  let characterList = contentBlock.getCharacterList()
  characterList = characterList
    .take(start)
    .concat(characterList.skip(start + len))
  return contentBlock.merge({ characterList, text: updatedText })
}

export const _applyColor = (colorClass, start, end) => (
  characterMetadata,
  index
) => {
  const inRange = index >= start && index < end
  return inRange
    ? CharacterMetadata.applyStyle(
        characterMetadata,
        `${COLOR_STYLE_PREFIX}${colorClass}`
      )
    : characterMetadata
}

export const _highlightsApplyMark = (contentBlock) => {
  if (contentBlock.getType() === 'atomic') {
    return null
  }

  let match = _regexSearch(START_MARK_REGEX, contentBlock.getText())
  if (!match) {
    return null
  }

  let updatedBlock = _stripCharacters(
    contentBlock,
    match.index,
    match.fullMatch.length
  )

  END_MARK_REGEX.lastIndex = 0
  const endMatch = _regexSearch(END_MARK_REGEX, updatedBlock.getText())
  if (!endMatch) {
    return null
  }

  if (match.colorClass !== endMatch.colorClass) {
    // Color class mismatch
    return null
  }

  updatedBlock = _stripCharacters(
    updatedBlock,
    endMatch.index,
    endMatch.fullMatch.length
  )

  const characterList = updatedBlock
    .getCharacterList()
    .map(_applyColor(match.colorClass, match.index, endMatch.index))
  return updatedBlock.merge({ characterList })
}

const applyUntilNull = (contentBlock) => {
  let prevBlock
  do {
    prevBlock = contentBlock
    contentBlock = _highlightsApplyMark(prevBlock)
  } while (contentBlock !== null)
  return prevBlock
}

export const highlightsApplyMarks = (data) => {
  data.contentBlocks = data.contentBlocks.map(applyUntilNull)
  return data
}
